module.exports = __webpack_public_path__ + "img/big_1_32.8f3d3281.png";